document.addEventListener("click", function (e) {
  // Garante que o click reconheça o botão mesmo se clicar no texto interno
  const btn = e.target.closest("button");
  if (!btn) return;

  // MINUS
  if (btn.classList.contains("CartItem__QtyBtn--minus")) {
    const item = btn.closest(".CartItem");
    if (!item) return;

    const input = item.querySelector(".CartItem__QtyInput");
    const newQty = Math.max(1, parseInt(input.value) - 1);

    updateCartItem(item.dataset.itemKey, newQty);
  }

  // PLUS
  if (btn.classList.contains("CartItem__QtyBtn--plus")) {
    const item = btn.closest(".CartItem");
    if (!item) return;

    const input = item.querySelector(".CartItem__QtyInput");
    const newQty = parseInt(input.value) + 1;

    updateCartItem(item.dataset.itemKey, newQty);
  }

  // REMOVER
  if (btn.classList.contains("CartItem__RemoveMini")) {
    const item = btn.closest(".CartItem");
    if (!item) return;

    updateCartItem(item.dataset.itemKey, 0);
  }
});

async function updateCartItem(key, qty) {
  try {
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updates: { [key]: qty }
      })
    });

    if (!res.ok) {
      console.error("Erro ao atualizar o carrinho");
      return;
    }

    // Alguns temas têm refresher interno
    const refreshEvent = new CustomEvent("cart:refresh", { bubbles: true });
    document.documentElement.dispatchEvent(refreshEvent);

    // Atualiza a página se o tema não suportar auto-refresh
    setTimeout(() => location.reload(), 150);

  } catch (err) {
    console.error("Erro:", err);
  }
}
